import apiConfig from '../apiConfig';

export const getEmployeeTransactions = async (at, data) => {
	const response = await apiConfig.post(
		'/API/REPORTS/REQUESTS/GET_USERS_REQUESTS_STEPS_LIST', {
            ...data,
            PageSize: 1000,
            PageIndex: 1
        }, 
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

    if (response.data.Status) {
        return response.data.Data.Data
    }

    return []
};